import axios from "axios";
import { useEffect, useState, useMemo } from "react";
import submittedImg from "../../assets/stylesheets/static/media/submit-response.svg";
import { useSearchParams } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import pollsCss from "../../assets/styles/polls/polls.module.scss";

const ThankYou = () => {
  const [params] = useSearchParams();
  const slug = params.get("slug");
  const submittedOption = params.get("submitted_option");

  const [pollResponse, setPollResponse] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchSinglePoll = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_DOMAIN_URL}/api/v1/polls/${slug}`
      );
      setPollResponse(response.data);
    } catch (error) {
      console.error("Error fetching poll response:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSinglePoll();
  }, []);

  const thankYouPage = useMemo(
    () => pollResponse?.poll?.template_data?.thankYouPage,
    [pollResponse]
  );

  const renderPollOptions = () => {
    if (!pollResponse?.aggregate?.options) return null;

    return pollResponse.aggregate.options.map((option, index) => {
      const fontSize =
        pollResponse.poll.poll_type === "rating" &&
        isNaN(Number(option.option_text))
          ? `${12 + index * 1.5}px`
          : "16px";
      return (
        <>
          {(!option?.archived ||
            (option?.archived && option.percentage > 0)) && (
            <div className={pollsCss.pollOption} key={index}>
              <div className={pollsCss.optionRow}>
                <span className={pollsCss.percentage}>
                  {option.percentage}%
                </span>
                <div className={pollsCss.optionBarContainer}>
                  <div
                    className={`${pollsCss.optionBar} ${Number.parseInt(submittedOption) === option?.poll_option_id ? pollsCss.submittedOptionBar : ""}`}
                    style={{ width: `${option.percentage}%` }}
                  ></div>
                  {pollResponse?.poll?.poll_type === "multiple-choice" &&
                  pollResponse?.poll?.template_data?.variant === "gif" ? (
                    <div />
                  ) : (
                    <span
                      className={pollsCss.optionName}
                      style={{ fontSize: fontSize }}
                    >
                      {option.option_text}
                    </span>
                  )}
                </div>
                {pollResponse?.poll?.poll_options[index]?.option_template_data
                  ?.gif_url && (
                  <div>
                    <img
                      src={
                        pollResponse?.poll?.poll_options[index]
                          ?.option_template_data?.gif_url
                      }
                      alt="gif"
                      className={` ${pollsCss.optionImg}`}
                    />
                  </div>
                )}
              </div>
            </div>
          )}
        </>
      );
    });
  };

  const renderGifOptions = () => {
    if (!pollResponse?.aggregate?.options) return null;

    return (
      <div className={pollsCss.gifOptionContainer}>
        {pollResponse.aggregate.options.map((option, index) => {
          if (option.archived) return null;
          return (
            <div key={index} className={`${pollsCss.gifOption} ${Number.parseInt(submittedOption) === option?.poll_option_id ? pollsCss.submittedGifOption : ""}`}>
              <img src={option?.gif_url} alt="gif" />
              <p className={pollsCss.percentageText}>{option.percentage}%</p>
            </div>
          );
        })}
      </div>
    );
  };

  const getWidth = (percentage) => {
    return `${Math.max(6, percentage)}%`;
  };

  const renderYesNoOptions = () => {
    if (!pollResponse?.aggregate?.options) return null;

    const activeOptions = pollResponse?.aggregate?.options?.filter(
      (option) => !option.archived
    );
    if (activeOptions.length < 2) return null;

    const [option1, option2] = activeOptions;

    return (
      <div className={pollsCss.yesNoOptionContainer}>
        <button
          className={pollsCss.yesNoOption}
          style={{
            fontSize:
              pollResponse?.poll?.template_data?.variant === "emoji"
                ? "23px"
                : "16px",
            width: getWidth(option1.percentage),
            backgroundColor: Number.parseInt(submittedOption) === option1?.poll_option_id ? "#DAD9DC" : "#f0f0f0",
            zIndex: 1,
          }}
        >
          {pollResponse?.poll?.template_data?.variant === "emoji"
            ? option1.emoji
            : option1.option_text}
            <p className={pollsCss.percentageText} style={{color: "#121212"}}>{option1.percentage}%</p>
        </button>

        <button
          className={pollsCss.yesNoOption}
          style={{
            fontSize:
              pollResponse?.poll?.template_data?.variant === "emoji"
                ? "23px"
                : "16px",
            width: getWidth(option2.percentage),
            backgroundColor: Number.parseInt(submittedOption) === option2?.poll_option_id ? "#DAD9DC" : "#f0f0f0",
            zIndex: 1,
          }}
        >
          {pollResponse?.poll?.template_data?.variant === "emoji"
            ? option2.emoji
            : option2.option_text}
            <p className={pollsCss.percentageText} style={{color: "#121212"}}>{option2.percentage}%</p>
        </button>
       

      </div>
    );
  };

  const renderScaleOptions = () => {
    if (!pollResponse?.aggregate?.options) return null;

    return (
      <div className={pollsCss.scaleContainer}>
        {pollResponse.aggregate.options.map((option, index) =>
          option.archived ? null : (
            <div
              key={index}
              className={`${pollsCss.scaleOption} ${Number.parseInt(submittedOption) === option?.poll_option_id ? pollsCss.submittedScaleOption : ""}`}
              style={{ fontSize: pollResponse?.poll?.template_data?.translateToEmojis  ? `${(12 + (2 * index))*0.8}px` : "18px" }}
            >
              {pollResponse?.poll?.template_data?.translateToEmojis  ? option.emoji : option.option_text}
              <p className={pollsCss.percentageText}>{option.percentage}%</p>
            </div>
          )
        )}
      </div>
    );
  };

  if (loading) {
    return (
      <div className={pollsCss.loaderContainer}>
        <ClipLoader color={"#123abc"} loading={loading} size={50} />
      </div>
    );
  }

  return (
    <div
      className={pollsCss.thankYouContainer}
      style={{
        backgroundColor: thankYouPage?.backgroundColor
          ? `#${thankYouPage.backgroundColor}`
          : "#f6f6f6",
        height: "100vh",
      }}
    >
      {/* <div className={pollsCss.thankYouHeader}>
        <img src={"/logo.png"} alt="Logo" />
      </div> */}
      <div className={pollsCss.inner}>
        <img
          src={
            thankYouPage?.icon
              ? `${thankYouPage.basePath}${thankYouPage.icon}`
              : submittedImg
          }
          onError={(e) => (e.target.src = submittedImg)}
          className={pollsCss.thankYouImage}
          alt="Thank You"
        />
        <h1
          className={pollsCss.heading}
          style={{
            color: thankYouPage?.text ? `#${thankYouPage.text}` : "#606062",
          }}
        >
          {thankYouPage?.title || "Thank You"}
        </h1>
        <p
          className={pollsCss.text}
          style={{
            color: thankYouPage?.text ? `#${thankYouPage.text}` : "#606062",
          }}
        >
          {pollResponse?.poll?.template_data?.isPollExpired &&
          pollResponse?.poll?.template_data?.hasEndDate
            ? pollResponse?.poll?.template_data?.closingText
            : thankYouPage?.description || "Your feedback is valuable for us"}
        </p>
      </div>
      {pollResponse?.poll?.template_data?.resultOnThankYouPage && (
        <div className={pollsCss.pollContainer}>
          <h1 className={pollsCss.pollQuestion}>{pollResponse?.poll?.template_data?.question}</h1>
          {pollResponse?.poll?.poll_type === "multiple-choice" &&
            pollResponse?.poll?.template_data?.variant === "text" &&
            renderPollOptions()}
          {pollResponse?.poll?.poll_type === "multiple-choice" &&
            pollResponse?.poll?.template_data?.variant === "gif" &&
            renderGifOptions()}
          {pollResponse?.poll?.poll_type === "yes-no" && renderYesNoOptions()}
          {pollResponse?.poll?.poll_type === "rating" && renderScaleOptions()}
        </div>
      )}
    </div>
  );
};

export default ThankYou;
